import CommonHead from "components/common-head";
import SEO from "components/seo";
import { SEO_META, SEO_AUTHOR } from "../constants";
import Head from "next/head";
import Router from "next/router";
import React from "react";
import { useEffect } from "react";
import CommonPostBody from "components/common-post-body";

export default function RedirectPage({
  path,
  text,
  title,
  desc,
}: {
  path: string;
  text: string;
  title: string;
  desc: string;
}) {
  useEffect(() => {
    Router.push(path);
  });

  return (
    <React.Fragment>
      <CommonHead />
      <SEO
        title={title}
        description={desc}
        author={SEO_AUTHOR}
        meta={SEO_META}
      />
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
      <CommonPostBody />
      <p>{text}</p>
    </React.Fragment>
  );
}
